$(document).on('turbo:load', function() {

  $('#survey_select').change(function() {
    let selectedSurveyId = $(this).val();

    // Hide all survey question sections
    $('.survey-questions').hide();

    // Show the selected survey question section
    $('#survey_questions_' + selectedSurveyId).show();

    if (selectedSurveyId !== '') {
      $('#submit_button').show();
    } else {
      $('#submit_button').hide();
    }
  });

  $('#submit_button').on('click', function(e) {
    e.preventDefault();

    // trigger the form's submit event
    $('#survey_form').submit();
  });

  $('.scale-cell:not(.disabled)').on('click', function() {
    let table = $(this).closest('.survey-scale-table');
  
    // Remove the 'selected' class from all cells of the same table
    table.find('.scale-cell').removeClass('selected');
  
    // Add the 'selected' class to the clicked cell and change its color
    $(this).addClass('selected');
  
    // Update the hidden input field value for this question
    let questionId = table.data('questionId');
    let selectedScaleValue = $(this).text();
    let targetField = $('#scale_answer_' + questionId);
    targetField.val(selectedScaleValue);
  });

  $('.custom-list-item').on('click', function() {
    let listItem = $(this);
    let bullet = listItem.find('.bullet');
    let questionId = listItem.closest('.custom-list').find('input[type=hidden]').attr('id').split('_');
    let selectType = questionId[questionId.length - 4]; // Get the select type (multi or single)
    questionId = questionId.pop(); // Get the question ID
  
    // If the item was previously selected, unselect it
    if (bullet.hasClass('selected')) {
      bullet.removeClass('selected');
    } else {
      if (selectType == 'single') {
        // If it's single select, unselect all bullets first
        listItem.siblings().find('.bullet').removeClass('selected');
      }
  
      // Select the clicked bullet
      bullet.addClass('selected');
    }
  
    let selectedAnswers = [];
  
    // Loop through all selected list items and save their answers
    listItem.closest('.custom-list').find('.selected').each(function() {
      selectedAnswers.push($(this).closest('.custom-list-item').data('answer'));
    });
  
    // Update the hidden input field value for this question
    $('#' + selectType + '_select_answer_' + questionId).val(selectedAnswers.join(', '));
  });

  $('textarea').on('input', function() {
    let textArea = $(this);
    let questionId = textArea.attr('id').split('_').pop(); // Get the question ID
    let selectType = textArea.attr('id').split('_')[0]; // Get the select type (long_text or short_text)
    // Update the hidden input field value for this question
    $('#' + selectType + '_answer_input_' + questionId).val(textArea.val());
  });

  $(".word-break").each(function() {
    let text = $(this).text();
    let words = text.split(" ");
    let result = "";
    
    while (words.length > 0) {
      result += words.splice(0, 10).join(" ") + "<br>";
    }
    
    $(this).html(result);
  });

  $('form').on('submit', function(e) {
    let valid = true;
  
    $('[data-required=true]').each(function() {
      let feedbackElement = $(this).next('.invalid-feedback.question-feedback');
      if ($(this).val() == '') {
        valid = false;
        feedbackElement.addClass('show');

        // Hide the feedback after 3 seconds
        setTimeout(function() {
          feedbackElement.removeClass('show');
        }, 3000);
      } else {
        feedbackElement.removeClass('show');
      }
    });

    if (!valid) {
      e.preventDefault(); // Prevent form submission
      return false;
    }
  });  
  
});
